import { render, staticRenderFns } from "./ProductsBox.vue?vue&type=template&id=346fffe8&scoped=true"
import script from "./ProductsBox.vue?vue&type=script&lang=js"
export * from "./ProductsBox.vue?vue&type=script&lang=js"
import style0 from "./ProductsBox.vue?vue&type=style&index=0&id=346fffe8&prod&scoped=true&lang=css"
import style1 from "./ProductsBox.vue?vue&type=style&index=1&id=346fffe8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346fffe8",
  null
  
)

export default component.exports